console.log('enter')
if(document.getElementsByClassName('scrollBtn')) {
  const scrollBtns = document.querySelectorAll('.scrollBtn');
  scrollBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = btn.href.split('#').pop();
      scrollTo(targetId);
    })
  })
}

function scrollTo(id) {
  const targetEl = document.getElementById(id);
  console.log(targetEl)

  const rect = targetEl.getBoundingClientRect();
  const headerHeight = window.matchMedia('(max-width: 749px)').matches ? 0 : document.getElementsByTagName('header')[0].offsetHeight;
  const position = window.scrollY + rect.top - headerHeight;
  window.scroll({
    top: position,
    behavior: "smooth",
  });
 }